import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'avano-avano-appheader-icon',
  template: `
  <i
    #iconRef
    [class]="'avano-appheader-icon ' + icon"
    [attr.title]="title?.length? title : undefined"
    [class.avano-appheader-icon-disabled]="disabled"
    [class.avano-appheader-item-clickable]="!disabled"
  >
  </i>
  `,
  styleUrls: ['./avano-appheader-icon.component.scss']
})
export class AvanoAppheaderIconComponent {
  @Input() title = '';
  @Input() icon = '';
  @Input() disabled: boolean;

  @HostBinding('class.avano-appheader-item') isAppheaderItem = true;
}
